import styled from 'styled-components';

export const CaseIdText = styled.p<{
  margin?: string;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: ${(props) => (props.margin ? props.margin : '0')};
`;

export const CaseIdContainer = styled.div`
  display: flex;
  align-items: flex-end;
  white-space: nowrap;
  overflow: hidden;
  margin: 0 0 0 13px;
`;
